import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ProductLotService } from 'src/app/services/product-lot.service';
import { ProductPriceService } from 'src/app/services/product-price.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Category } from 'src/app/models/category';
import { ProductPrice } from 'src/app/models/product';


export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-product-price-dialog',
  templateUrl: './product-price-dialog.component.html',
  styleUrls: ['./product-price-dialog.component.scss']
})
export class ProductPriceDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public priceForm: FormGroup;
  public currentCategory: Category;

  constructor(
    public _productLotService: ProductLotService,
    public _productPriceService: ProductPriceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this._productPriceService.currentProductLot = this.data.lot;
    this._productPriceService.currentProductPrice = this.data.price;

    this.priceForm = this._productPriceService.createPriceForm();
    this._productPriceService.loadCategories()
  }

  selectCategory(category) {

    const cat = this._productPriceService.arrayCategories.find(function (e) {
      return e.id == category;
    });
    this.currentCategory = cat;

  }


  addPrice() {

    this.priceForm.controls.category_id.setValue(this.currentCategory.id)
    this.priceForm.controls.category_name.setValue(this.currentCategory.name)

    if (this.priceForm.valid) {

      let price: ProductPrice = new ProductPrice()
      price.lot_id = this.priceForm.controls.lot_id.value
      price.category_id = this.priceForm.controls.category_id.value
      price.category_name = this.priceForm.controls.category_name.value

      price.value = Number(this.priceForm.controls.value.value)

      console.log("productPriceAded: " + JSON.stringify(price))
      this._productPriceService.insert(price);

    }
  }


}
